const tagCategoryColors: string[] = []

tagCategoryColors[1] = '#750000';
tagCategoryColors[2] = '#c47400';
tagCategoryColors[3] = '#0038c4';



export default tagCategoryColors;

